import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { HANDOVER_STATUS_ACCEPTED } from 'src/app/handover-constants';
import { Abandon, AdditionalPlug } from 'src/app/interfaces/abandon';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { PendingChanges } from '../shared/pending-changes.class';

@Component({
  selector: 'app-handover-detail-abandon',
  templateUrl: './handover-detail-abandon.component.html',
  styleUrls: ['./handover-detail-abandon.component.scss'],
  standalone: false,
})
export class HandoverDetailAbandonComponent
  extends PendingChanges
  implements OnInit
{
  @Input() handoverId: number | undefined;
  @Input() wellId: string | undefined;
  @Input() handoverStatusId: number | undefined;
  @Input() readOnlyContent!: boolean;

  abandon: Abandon[] = [];
  mdSupportPlugTop?: number;
  displayedColumns = [
    'plugType',
    'mdTopStage',
    'mdBaseStage',
    'topCheck',
    'mdTopChecked',
    'supportPlugType',
    'mdSupportPlugTop',
    'actions',
  ];
  isLoading = false;
  hideFooter = true;

  originalAbandon: Abandon[] = [];
  isDisabled: boolean[] = [];
  showFooterNoDataOrign = false;
  additionalPlugs: AdditionalPlug[] = [];
  originalAdditionalPlugs: AdditionalPlug[] = [];
  isDisabledPlugs: boolean[] = [];

  constructor(
    public handoverService: HandoverService,
    private notificationService: NotificationService,
    public dialogService: DialogService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handoverService) {
      this.setAbandonDataSource();
      this.setAdditionalPlugsDataSource();
      this.showFooterNoDataOrign =
        this.handoverStatusId != HANDOVER_STATUS_ACCEPTED;
    }
  }

  setAbandonDataSource(): void {
    this.isLoading = true;
    this.handoverService
      .getAbandon(this.handoverId!, this.wellId!, this.handoverStatusId!)
      .subscribe((abandon: Abandon[]) => {
        this.abandon = abandon;
        this.isLoading = false;
        this.hideFooter = abandon.length > 0;
        this.setOriginalAbandonValues(abandon);
      });
  }

  setOriginalAbandonValues(abandon: Abandon[]): void {
    abandon.map((val) => {
      if (val.comment == null) val.comment = '';
      this.originalAbandon.push(Object.assign({}, val));
      this.isDisabled.push(true);
    });
  }

  saveAbandon(item: Abandon, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Abandono',
      '¿Desea guardar los cambios realizados?'
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        item.handoverId = this.handoverId;
        const abandon: Abandon[] = [];
        abandon.push(item);

        this.handoverService
          .saveAbandon(abandon)
          .subscribe((savedAbandon: Abandon[]) => {
            if (savedAbandon) {
              this.notificationService.notify(
                'Los cambios de abandono se han guardado con éxito.',
                true
              );
              this.isDisabled[index] = true;
              this.originalAbandon[index].topCheck = item.topCheck;
              this.originalAbandon[index].mdTopChecked = item.mdTopChecked;
              this.originalAbandon[index].supportPlugType =
                item.supportPlugType;
              this.originalAbandon[index].mdSupportPlugTop =
                item.mdSupportPlugTop;
              this.originalAbandon[index].comment = item.comment;
              this.reportPendingChanges();
            } else {
              this.notificationService.notify(
                'Ocurrió un error al grabar los cambios de abandono.',
                false
              );
            }
          });
      }
    });
  }

  openComments(
    comment: string | undefined,
    index: number,
    event: any,
    readOnly: boolean
  ): void {
    const target = new ElementRef(event.currentTarget);
    this.dialogService
      .openCommentDialog('Comentarios', comment, target, -200, -450, readOnly)
      .afterClosed()
      .subscribe((comment: string) => {
        this.abandon[index].comment = comment;
        this.enableSaveButton(
          index,
          comment,
          this.abandon[index].topCheck,
          this.abandon[index].mdTopChecked,
          this.abandon[index].supportPlugType,
          this.abandon[index].mdSupportPlugTop
        );
      });
  }

  enableSaveButton(
    index: number,
    comment: string | undefined,
    topCheck: boolean,
    mdTopChecked: number | undefined,
    supportPlugType: string | undefined,
    mdSupportPlugTop: number | undefined
  ): void {
    const enable =
      topCheck != this.originalAbandon[index].topCheck ||
      mdTopChecked != this.originalAbandon[index].mdTopChecked ||
      supportPlugType != this.originalAbandon[index].supportPlugType ||
      mdSupportPlugTop != this.originalAbandon[index].mdSupportPlugTop ||
      comment != this.originalAbandon[index].comment;
    this.isDisabled[index] = !enable;
    this.reportPendingChanges();
  }

  reportPendingChanges(): void {
    let thereAreChanges = false;
    for (let index = 0; index < this.abandon.length; index++) {
      thereAreChanges =
        thereAreChanges ||
        this.abandon[index].topCheck != this.originalAbandon[index].topCheck ||
        this.abandon[index].mdTopChecked !=
          this.originalAbandon[index].mdTopChecked ||
        this.abandon[index].supportPlugType !=
          this.originalAbandon[index].supportPlugType ||
        this.abandon[index].mdSupportPlugTop !=
          this.originalAbandon[index].mdSupportPlugTop ||
        this.abandon[index].comment != this.originalAbandon[index].comment;
    }
    for (let index = 0; index < this.additionalPlugs.length; index++) {
      thereAreChanges =
        thereAreChanges ||
        this.additionalPlugs[index].plugType !=
          this.originalAdditionalPlugs[index].plugType ||
        this.additionalPlugs[index].mdBaseStage !=
          this.originalAdditionalPlugs[index].mdBaseStage ||
        this.additionalPlugs[index].mdTopStage !=
          this.originalAdditionalPlugs[index].mdTopStage ||
        this.additionalPlugs[index].topCheck !=
          this.originalAdditionalPlugs[index].topCheck ||
        this.additionalPlugs[index].mdTopChecked !=
          this.originalAdditionalPlugs[index].mdTopChecked ||
        this.additionalPlugs[index].supportPlugType !=
          this.originalAdditionalPlugs[index].supportPlugType ||
        this.additionalPlugs[index].mdSupportPlugTop !=
          this.originalAdditionalPlugs[index].mdSupportPlugTop ||
        this.additionalPlugs[index].comment !=
          this.originalAdditionalPlugs[index].comment;
    }
    this.emitPendingChanges(thereAreChanges);
  }

  setAdditionalPlugsDataSource(): void {
    this.isLoading = true;
    this.handoverService
      .getAdditionalPlugs(this.handoverId!)
      .subscribe((additionalPlug: AdditionalPlug[]) => {
        this.additionalPlugs = additionalPlug;
        this.isLoading = false;
        this.additionalPlugs.push({} as AdditionalPlug);
        this.hideFooter = additionalPlug.length > 0;
        this.setOriginalAdditionalPlugsValues(additionalPlug);
        this.originalAdditionalPlugs.push({} as AdditionalPlug);
        this.isDisabledPlugs.push(true);
      });
  }

  setOriginalAdditionalPlugsValues(additionalPlug: AdditionalPlug[]): void {
    additionalPlug.map((val) => {
      if (val.supportPlugType == null) val.supportPlugType = '';
      if (val.comment == null) val.comment = '';
      this.originalAdditionalPlugs.push(Object.assign({}, val));
      this.isDisabledPlugs.push(true);
    });
  }

  deleteAdditionalPlugs(additionalPlugId: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Abandono',
      `¿Está seguro de que desea eliminar el Tapon adicional?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.isLoading = true;
        this.handoverService
          .deleteAdditionalPlugs(this.handoverId!, additionalPlugId)
          .subscribe((boolean) => {
            if (boolean) {
              this.notificationService.notify(
                `El Tapon adicional en Abandono se ha eliminado con éxito.`,
                true
              );
              this.setAdditionalPlugsDataSource();
            } else {
              this.notificationService.notify(
                `Ocurrió un error al eliminar El Tapon adicional en Abandono .`,
                false
              );
            }
            this.isLoading = false;
          });
      }
    });
  }

  enablePlugsSaveButton(index: number, additionalPlug: AdditionalPlug): void {
    let enable = false;
    enable =
      additionalPlug.plugType != null &&
      additionalPlug.mdBaseStage != null &&
      additionalPlug.mdTopStage != null &&
      (additionalPlug.plugType != this.originalAbandon[index]?.plugType ||
        additionalPlug.mdBaseStage !=
          this.originalAbandon[index]?.mdBaseStage ||
        additionalPlug.mdTopStage != this.originalAbandon[index]?.mdTopStage ||
        additionalPlug.topCheck != this.originalAbandon[index]?.topCheck ||
        additionalPlug.mdTopChecked !=
          this.originalAbandon[index]?.mdTopChecked ||
        additionalPlug.supportPlugType !=
          this.originalAbandon[index]?.supportPlugType ||
        additionalPlug.mdSupportPlugTop !=
          this.originalAbandon[index]?.mdSupportPlugTop ||
        additionalPlug.comment != this.originalAbandon[index]?.comment);
    this.isDisabledPlugs[index] = !enable;
    this.reportPendingChanges();
  }

  openCommentsPlug(
    comment: string | undefined,
    index: number,
    event: any,
    readOnly: boolean
  ): void {
    const target = new ElementRef(event.currentTarget);
    this.dialogService
      .openCommentDialog('Comentarios', comment, target, -200, -450, readOnly)
      .afterClosed()
      .subscribe((comment: string) => {
        this.additionalPlugs[index].comment = comment;
        this.enablePlugsSaveButton(index, this.additionalPlugs[index]);
      });
  }

  saveAdditionalPlug(item: AdditionalPlug, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Abandono',
      '¿Desea guardar los cambios del Tapon Adicional?'
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        item.handoverId = this.handoverId;
        const additionalPlug: AdditionalPlug[] = [];
        additionalPlug.push(item);

        this.handoverService
          .saveAdditionalPlugs(this.handoverId!, additionalPlug)
          .subscribe((savedAdditionalPlug: AdditionalPlug[]) => {
            if (savedAdditionalPlug) {
              this.notificationService.notify(
                'Los cambios de abandono se han guardado con éxito.',
                true
              );
              this.setAdditionalPlugsDataSource();
              this.isDisabledPlugs[index] = true;
              this.reportPendingChanges();
            } else {
              this.notificationService.notify(
                'Ocurrió un error al grabar los cambios de abandono.',
                false
              );
            }
          });
      }
    });
  }
}
